import { camelizeKeys, decamelizeKeys } from 'humps';
import Cookie from 'js-cookie';
import { ActionType, Dispatch } from 'types';
import { Middleware, AnyAction } from 'redux';
/**
 * Primarily, this middleware allows us to not care about: setting
 * `options.credentials` to 'include', and snake casing keys in body objects
 * so they match naming conventions on the Python backend and camelizing keys in
 * response JSON.
 */

const HTTPSRegexp = /^https?:\/\//;

const reduxQueryConfigEnhancer: Middleware =
  (/* store */) => (next: Dispatch) => (action: AnyAction) => {
    const csrfToken = Cookie.get('csrftoken');

    switch (action.type) {
      case ActionType.RequestAsync: {
        const { body, transform, options = {}, type, url, ...rest } = action;
        const { dontCamelizeKeys, ...restOptions } = options;
        return next({
          body: decamelizeKeys(body),
          options: {
            credentials: 'include',
            ...restOptions,
            headers: {
              // TODO add auth headers
              'X-CSRFToken': csrfToken,
              ...options.headers,
            },
          },
          transform: (responseJson: {}, responseText: string): {} => {
            const _responseJson = dontCamelizeKeys ? responseJson : camelizeKeys(responseJson);
            return transform ? transform(_responseJson, responseText) : _responseJson;
          },
          type,
          url: HTTPSRegexp.test(url) ? url : `${window.el8Globals.BASE_URL}/${url}`,
          ...rest,
        });
      }

      case ActionType.MutateAsync: {
        const { body, transform, options = {}, type, url, ...rest } = action;
        const { dontCamelizeKeys, dontDecamelizeKeys, ...restOptions } = options;
        return next({
          body: dontDecamelizeKeys ? body : decamelizeKeys(body),
          options: {
            credentials: 'include',
            ...restOptions,
            headers: {
              // TODO add auth headers
              'X-CSRFToken': csrfToken,
              ...options.headers,
            },
          },
          transform: (responseJson: {}, responseText: string): {} => {
            const _responseJson = dontCamelizeKeys ? responseJson : camelizeKeys(responseJson);
            return transform ? transform(_responseJson, responseText) : _responseJson;
          },
          type,
          url: HTTPSRegexp.test(url) ? url : `${window.el8Globals.BASE_URL}/${url}`,
          ...rest,
        });
      }

      default:
        return next(action);
    }
  };

export default reduxQueryConfigEnhancer;
